module.exports = __webpack_public_path__ + "static/process3-1ca434fe5fba5f498deab5a9d5f23eb7.png";